import React from 'react';
import { useSingleTourGuide } from "./interactiveGuide";

export const withTourGuide = (WrappedComponent) => {
    return (props) => {
        const { showGuide, Overlay, isGuideActive, disabledKeys } = useSingleTourGuide();

        return (
            <>
                <WrappedComponent
                    {...props}
                    showGuide={showGuide}
                    Overlay={Overlay}
                    isGuideActive={isGuideActive}
                    disabledKeys={disabledKeys}
                />
                {Overlay && <Overlay />}
            </>
        );
    };
};